// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    categoriesKv: new Map(),  // 分类键值对
    loading: false,
    error: null,
    hasLoaded: false  // 新增：标记是否已加载过

  },
  
  getters: {
    // 通过 k 取得 v
    getCategoryValue: state => key => state.categoriesKv.get(key),
    
    // 获取整个 map（如果需要）
    getCategories: state => state.categoriesKv,
    
    // 检查 key 是否存在
    hasCategoryKey: state => key => state.categoriesKv.has(key),

    getMapSize: state => state.categoriesKv.size,
  },
  
  mutations: {
    // 全量更新 categoriesKv
    SET_CATEGORIES_KV(state, data) {
      state.categoriesKv = new Map(data)
      console.log("saved")

    },
    
    // 设置加载状态
    SET_LOADING(state, isLoading) {
      state.loading = isLoading
    },
    
    // 设置错误信息
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  
  actions: {
    // 全量更新分类数据
    async updateCategories({ commit }, categoriesData) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      
      try {
        // 如果传入的是普通对象，转换为 Map
        let mapData
        if (categoriesData instanceof Map) {
          mapData = categoriesData
        } else {
          mapData = new Map(Object.entries(categoriesData))
        }
        
        commit('SET_CATEGORIES_KV', mapData)
        return mapData
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    
    // 从 API 加载分类数据
    async loadCategoriesFromAPI({ commit, state, dispatch },axios,force = false) {
        console.log("loadCategoriesFromAPI")
        console.log(axios)
        if (!force && state.categoriesKv.size > 0) {
            return state.categoriesKv
        }
        try {
            const response = await axios.get('/api/category/kv')
            console.log(response)
            const data = response.data
            console.log(data)
            await dispatch('updateCategories', data)
            return data
        } catch (error) {
            commit('SET_ERROR', error.message)
            throw error
        }
    },
    
    
  }
})